import useTranslation from "next-translate/useTranslation";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import CustomJumbotron from "../components/ReuseableCompos/CustomJumbotron";
import SEO from "../components/Seo";

const ZakatLayout = ({ children }) => {
  const { t } = useTranslation("common");

  return (
    <>
      <SEO title={t(`zakat`)} description={t(`zakat`)} />
      <div className="">
        <CustomJumbotron
          p="py-4"
          m="mt-0"
          breadCrumbM="my-0"
          className="mt-0 border-bottom"
          title={t(`zakat`)}
          desc={t(`zakat`)}
          customBreadCrumbs={<CustomBreadCrumbs />}
          borderBottom={false}
        />
        <div className="container mb-4">{children}</div>
      </div>
    </>
  );
};

export default ZakatLayout;
